import { Grid } from '@mui/material'
import { Box } from '@mui/system'
import React, { Component } from 'react'
import TotalInvestments from '../../widgets/TotalInvestments'

export class Investments extends Component {
    render() {
        return (
            <Box className="dashboard-wrapper" sx={{ flexGrow: 1 }}>
          <Grid maxWidth="md" mx={"auto"}>
        <Grid container rowGap={2} columnSpacing={2}>
          <Grid item md={12} xs={12} sx={{display:"flex"}}>
            <TotalInvestments gid={this.props.gid} />
          </Grid>
        </Grid>
        </Grid>
      </Box>
        )
    }
}

export default Investments
